const firstArray = (...values) => values.find(Array.isArray) || [];

export const normalizeLuckyResults = (response) =>
  firstArray(
    response,
    response?.data,
    response?.results,
    response?.content,
    response?.data?.data,
    response?.data?.results,
    response?.data?.content
  )
    .filter((result) => result && typeof result === "object")
    .slice(0, 10);

export const luckyResultWinner = (result) => {
  const directWinner = result?.winner ?? result?.roundWinner ?? result?.number;
  if (directWinner !== undefined && directWinner !== null && directWinner !== "") {
    return String(directWinner).trim();
  }

  const resultGroups = Array.isArray(result?.results) ? result.results : [];
  const directRunner = resultGroups.find(
    (runner) => String(runner?.result || "").toUpperCase() === "WINNER"
  );
  if (directRunner?.runnerName !== undefined) return String(directRunner.runnerName).trim();

  for (const group of resultGroups) {
    const runners = Array.isArray(group?.runners) ? group.runners : [];
    const winningRunner = runners.find(
      (runner) => String(runner?.result || "").toUpperCase() === "WINNER"
    );
    if (!winningRunner) continue;
    return String(
      winningRunner.runnerName ??
      group?.runnersName?.[winningRunner.selectionId] ??
      winningRunner.selectionId ??
      ""
    ).trim();
  }

  return "";
};
